import { Injectable, inject } from '@angular/core';
import { Observable, catchError, of, tap, throwError } from 'rxjs';

import { AuthHttpService } from '@app/security/data-access/auth.http.service';
import { UserDetailsStorageService } from '@app/security/data-access/user/user-details-storage.service';
import { MeUser } from '@app/security/data-access/user/user.types';

@Injectable({ providedIn: 'root' })
export class UserService {
  private authHttp = inject(AuthHttpService);
  private userDetailsStorageService = inject(UserDetailsStorageService);

  initializeUser(): Observable<MeUser | null> {
    return this.fetchAndStoreUserDetails();
  }

  resetUser(): void {
    this.userDetailsStorageService.clearUserDetails();
  }

  private fetchAndStoreUserDetails(): Observable<MeUser | null> {
    return this.authHttp.fetchUserDetails().pipe(
      tap((userDetails) => this.userDetailsStorageService.setUserDetails(userDetails)),
      catchError((error) => {
        if (error.status === 401) {
          this.resetUser();
          return of(null);
        }
        return throwError(() => error);
      })
    );
  }
}
